import { call, fork, put, take, takeEvery, takeLatest } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
  OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY,
  OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_CLICK_ADD_OUTLET,
  OUTLET_PAGE_LIST_CLICK_CANCEL,
  OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET,
  OUTLET_PAGE_LIST_CLICK_OUTLET_ROW,
  OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET,
  OUTLET_PAGE_LIST_GET_BILLING,
  OUTLET_PAGE_LIST_GET_OUTLET_PRICE,
  OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS,
  OUTLET_PAGE_LIST_PAGE_REQUEST,
  OUTLET_PAGE_LIST_SEARCH,
  OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE,
  OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE,
  OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA
} from 'actions/outletPages/list/constants'
import * as apiProfile from 'api/profile'
import * as apiOutlet from 'api/outlets'
import * as actOutletList from 'actions/outletPages/list'
import * as actNotif from 'actions/notifications'
import * as act from 'actions'
import * as apiBilling from 'api/billing'
import { setNotificationMessage, setNotificationType } from 'actions/billingRedirect'
import { showBillingNotification } from 'actions/billingNotification'
import { initialize } from 'redux-form'
import { showPageLoadingSpinner } from 'actions/loadingSpinner'
import { phoneNumberFormatter } from 'utils/formatter'
import * as _ from 'lodash'
import * as mpOutletList from 'mixpanel/outlets/list'

function * fillForm (outlet) {
  let form = {
    id: outlet.id,
    businessId: outlet.business_id,
    name: outlet.name,
    address: outlet.address,
    postal: outlet.postal_code,
    city: outlet.city,
    province: outlet.province,
    phone: !outlet.phone_number ? null : phoneNumberFormatter(outlet.phone_number)
  }
  yield put(initialize('outlet', form))
}

export function * setUsedAndTotalOutletSlots (profile, outlets) {
  // count outlets
  let outletSlots = profile.business.outlet_slot
  let usedOutletSlots = 0
  _.forEach(outlets, (outlet) => { if (!outlet.is_deleted) usedOutletSlots++ })

  yield put(actOutletList.setOutletSlots(outletSlots))
  yield put(actOutletList.setUsedOutletSlots(usedOutletSlots))
}

function * openRightColumn () {
  yield put(actOutletList.openRightColumn())
}

function * closeRightColumn () {
  yield put(actOutletList.closeRightColumn())
}

export function * getBillingsFlow () {
  yield put(act.sendingRequest(true))
  yield put(act.showProgressBar())

  try {
    const response = yield call(apiBilling.getBillings)
    let pendingPaymentMessage = null
    _.forEach(response.data, (invoice) => {
      if (invoice.status === 'pending') {
        if (invoice.payment_type === 'credit_card') {
          pendingPaymentMessage = `There is a pending payment for ${invoice.invoice_number}. Please wait 24 hours before making a new payment.`
        } else if (invoice.payment_type === 'bank_transfer' || invoice.payment_type === 'echannel') {
          pendingPaymentMessage = `There is a pending payment for ${invoice.invoice_number}. Please transfer full amount of the invoice within 3 days before making a new payment.`
        }
        return false
      }
    })
    if (pendingPaymentMessage !== null) {
      yield put(actOutletList.setPendingPaymentMessage(pendingPaymentMessage))
      yield put(actOutletList.disablePayButton())
    }
  } catch (e) {

  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
  }
}

export function * pageRequest (request) {
  mpOutletList.outletListStart()
  // reset pages
  yield put(actOutletList.setOutletDetail(null))
  yield put(actOutletList.setOutlets([]))
  yield put(showPageLoadingSpinner(true))
  yield put(actOutletList.setUsedOutletSlots(null))
  yield put(actOutletList.setOutletSlots(null))
  yield call(closeRightColumn)

  try {
    yield put(act.sendingRequest(true))
    yield put(act.showProgressBar())

    let res = yield call(apiProfile.getProfile)
    yield put(actOutletList.setProfile(res.data))

    let resOutlet = yield call(apiOutlet.outlets, {with_inactive: true})
    yield put(actOutletList.setOutlets(resOutlet.data))

    yield put(actOutletList.getOutletPrice())
    yield put(actOutletList.getFeatureSubscriptionStatus())
    yield put(actOutletList.getBilling())
    yield put(showBillingNotification(request.payload.billingNotification))
    yield put(setNotificationType(null))
    yield put(setNotificationMessage(null))

    yield call(setUsedAndTotalOutletSlots, res.data, resOutlet.data)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * clickCreateOutlet () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(OUTLET_PAGE_LIST_CLICK_CREATE_OUTLET)
    try {
      yield put(act.sendingRequest(true))
      yield put(act.showProgressBar())

      let res = yield call(apiOutlet.getNew, {})
      yield put(actOutletList.setOutletDetail(null))
      yield call(fillForm, res.data)
      yield call(openRightColumn)
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.sendingRequest(false))
      yield put(act.hideProgressBar())
    }
  }
}

export function * clickAddOutlet () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(OUTLET_PAGE_LIST_CLICK_ADD_OUTLET)
    yield put(actOutletList.showAddOutletModal())
  }
}

export function * clickOutletRow () {
  // noinspection InfiniteLoopJS
  while (true) {
    let {payload: {outletId}} = yield take(OUTLET_PAGE_LIST_CLICK_OUTLET_ROW)
    try {
      yield put(act.sendingRequest(true))
      yield put(act.showProgressBar())

      let res = yield call(apiOutlet.getOutletById, outletId)
      yield put(actOutletList.setOutletDetail(res.data))
      yield call(fillForm, res.data)
      yield call(openRightColumn)
    } catch (error) {
      yield put(actNotif.error(error.message))
    } finally {
      yield put(act.sendingRequest(false))
      yield put(act.hideProgressBar())
    }
  }
}

export function * clickCancel () {
  // noinspection InfiniteLoopJS
  while (true) {
    yield take(OUTLET_PAGE_LIST_CLICK_CANCEL)
    yield put(actOutletList.setOutletDetail(null))
    yield call(fillForm, {})
    yield call(closeRightColumn)
  }
}

export function * submitFormCreate (action) {
  let {payload: {data, previousOutlets}} = action
  mpOutletList.outletListCreate({
    outlet: data.outlet
  })
  yield put(actOutletList.setDisableSaveOutletButton(true))
  yield put(act.sendingRequest(true))
  yield put(act.showProgressBar())

  try {
    // call api
    let response = yield call(apiOutlet.postOutlet, data)
    // set to reducers
    let outlet = response.data
    previousOutlets.unshift(outlet)

    yield put(actOutletList.setOutletDetail(outlet))
    yield put(actOutletList.setOutlets(previousOutlets))

    // call outlets and profile api to get count
    let resProfile = yield call(apiProfile.getProfile)
    let resOutlets = yield call(apiOutlet.outlets)
    yield call(setUsedAndTotalOutletSlots, resProfile.data, resOutlets.data)

    yield call(fillForm, outlet)

    yield put(actNotif.success('Outlet successfully created.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    yield put(actOutletList.setDisableSaveOutletButton(false))
  }
}

export function * submitFormUpdate (action) {
  let {payload: {data, outletId, previousOutlets}} = action
  yield put(act.sendingRequest(true))
  yield put(act.showProgressBar())
  yield put(actOutletList.setDisableSaveOutletButton(true))

  try {
    let response = yield call(apiOutlet.putOutletById, outletId, data)
    // set to reducers
    let outlet = response.data
    previousOutlets.forEach((po, idx) => {
      if (po.id === outlet.id) {
        previousOutlets[idx] = outlet
      }
    })
    yield put(actOutletList.setOutlets(previousOutlets))

    // call outlets and profile api to get count
    let resProfile = yield call(apiProfile.getProfile)
    let resOutlets = yield call(apiOutlet.outlets)
    yield call(setUsedAndTotalOutletSlots, resProfile.data, resOutlets.data)

    yield call(fillForm, outlet)

    yield put(actNotif.success('Outlet was successfully updated.'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    yield put(actOutletList.setDisableSaveOutletButton(false))
  }
}

export function * search (action) {
  yield put(initialize('outlet', {}))
  yield call(closeRightColumn)
  yield put(actOutletList.setOutlets([]))
  yield put(showPageLoadingSpinner(true))
  try {
    let {payload: {query}} = action
    // prevent too fast ajax call
    yield call(delay, 300)
    yield put(act.sendingRequest(true))
    yield put(act.showProgressBar())

    let resOutlet = yield call(apiOutlet.search, query)
    yield put(actOutletList.setOutlets(resOutlet.data))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    yield put(showPageLoadingSpinner(false))
  }
}

export function * askReactivateOutletWithoutPay (action) {
  let {payload: {outlet}} = action
  yield put(actOutletList.setReactivatedOutlet(outlet))
  yield put(actOutletList.showReactivateOutletWithoutPay())
}

export function * askReactivateOutlet (action) {
  let {payload: {outlet}} = action
  yield put(actOutletList.setReactivatedOutlet(outlet))
  yield put(actOutletList.showConfirmReactivateOutletModal())
}

export function * confirmReactivateOutletWithoutPayFlow (action) {
  let {payload: {outlet, previousOutlets}} = action
  yield put(actOutletList.setOnLoadingReactivateOutletWithoutPay(true))
  yield put(act.sendingRequest(true))
  yield put(act.showProgressBar())
  try {
    const res = yield call(apiOutlet.patchOutletById, outlet.id, {is_deleted: false}, {})
    previousOutlets.forEach((po, idx) => {
      if (po.id === res.data.id) previousOutlets[idx] = res.data
    })
    // call outlets and profile api to get count
    let resProfile = yield call(apiProfile.getProfile)
    let resOutlets = yield call(apiOutlet.outlets)
    yield call(setUsedAndTotalOutletSlots, resProfile.data, resOutlets.data)
    yield put(actOutletList.setOutletDetail(res.data))
    yield put(actOutletList.setOutlets(previousOutlets))
    yield put(actNotif.success('Outlet has been reactivated'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    yield put(actOutletList.setReactivatedOutlet(null))
    yield put(actOutletList.hideReactivateOutletWithoutPay())
    yield call(closeRightColumn)
    yield put(actOutletList.setOnLoadingReactivateOutletWithoutPay(false))
  }
}

export function * confirmReactivateOutlet (action) {
  const {billingData} = action.payload
  yield put(act.sendingRequest(true))
  yield put(actOutletList.disablePayButton())
  yield put(actOutletList.setOnLoading(true))
  let response = {}
  try {
    response = yield call(apiBilling.verifyBilling, billingData)
  } catch (e) {
    yield put(actOutletList.setReactivatedOutlet(null))
    yield put(actOutletList.hideConfirmReactivateOutletModal())
    yield put(actOutletList.setOnLoading(false))
    yield put(actOutletList.enablePayButton())
    yield put(actOutletList.showPaymentGatewayError())
  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
    if (response.data) {
      yield put(actOutletList.setPaymentButtonMessage('Redirecting to Veritrans'))
      window.location.replace(response.data.data.redirect_url)
    }
  }
}

export function * cancelReactivateOutlet () {
  yield put(actOutletList.setReactivatedOutlet(null))
  yield put(actOutletList.hideConfirmReactivateOutletModal())
}

export function * outletPriceFlow () {
  yield put(act.sendingRequest(true))
  yield put(act.showProgressBar())

  try {
    const response = yield call(apiOutlet.getOutletPrice)
    yield put(actOutletList.setOutletPrice(response.data))
    yield put(initialize('AddOutletModalForm', {
      countOutlet: 1
    }))
  } catch (e) {

  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
  }
}

export function * featureSubscriptionStatusFlow () {
  yield put(act.sendingRequest(true))
  yield put(act.showProgressBar())

  try {
    const response = yield call(apiBilling.getSubscriptionStatus)
    let subscribedFeature = []
    _.forEach(response.data, (feature) => {
      if (feature.is_active && (feature.is_subscribing || !feature.is_subscribing)) subscribedFeature.push(feature)
    })
    yield put(actOutletList.setFeatureSubscriptionStatus(subscribedFeature))
  } catch (e) {

  } finally {
    yield put(act.sendingRequest(false))
    yield put(act.hideProgressBar())
  }
}

export function * verifyAddOutletFlow (request) {
  yield put(act.sendingRequest(true))
  yield put(actOutletList.disablePayButton())
  yield put(actOutletList.setOnLoading(true))

  const {billingData} = request.payload
  let response = {}

  try {
    response = yield call(apiBilling.verifyBilling, billingData)
  } catch (e) {
    yield put(actOutletList.setOnLoading(false))
    yield put(actOutletList.enablePayButton())
    if (e.data) {
      yield put(actNotif.error(e.data.message))
    } else {
      yield put(actOutletList.hideAddOutletModal())
      yield put(actOutletList.showPaymentGatewayError())
    }
  } finally {
    yield put(act.sendingRequest(false))
    if (response.data) {
      yield put(actOutletList.setPaymentButtonMessage('Redirecting to Veritrans'))
      window.location.replace(response.data.data.redirect_url)
    }
  }
}

export default function * saga () {
  yield takeLatest(OUTLET_PAGE_LIST_PAGE_REQUEST, pageRequest)
  yield fork(clickOutletRow)
  yield fork(clickCancel)
  yield fork(clickCreateOutlet)
  yield fork(clickAddOutlet)
  yield takeLatest(OUTLET_PAGE_LIST_SEARCH, search)
  yield takeEvery(OUTLET_PAGE_LIST_SUBMIT_FORM_UPDATE, submitFormUpdate)
  yield takeEvery(OUTLET_PAGE_LIST_SUBMIT_FORM_CREATE, submitFormCreate)
  yield takeEvery(OUTLET_PAGE_LIST_ASK_REACTIVATE_OUTLET, askReactivateOutlet)
  yield takeEvery(OUTLET_PAGE_LIST_CONFIRM_REACTIVATE_OUTLET, confirmReactivateOutlet)
  yield takeEvery(OUTLET_PAGE_LIST_CANCEL_REACTIVATE_OUTLET, cancelReactivateOutlet)
  yield takeLatest(OUTLET_PAGE_LIST_GET_OUTLET_PRICE, outletPriceFlow)
  yield takeLatest(OUTLET_PAGE_LIST_GET_SUBSCRIPTION_STATUS, featureSubscriptionStatusFlow)
  yield takeLatest(OUTLET_PAGE_LIST_VERIFY_ADD_OUTLET_BILLING_DATA, verifyAddOutletFlow)
  yield takeLatest(OUTLET_PAGE_LIST_GET_BILLING, getBillingsFlow)
  yield takeLatest(OUTLET_PAGE_ASK_REACTIVATE_OUTLET_WITHOUT_PAY, askReactivateOutletWithoutPay)
  yield takeLatest(OUTLET_PAGE_CONFIRM_REACTIVATE_OUTLET_WITHOUT_PAY, confirmReactivateOutletWithoutPayFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/outletPages/list.js